/** Surface level deep object difference finder */
export const getObjectDifferences = (objectOne, objectTwo, labelOne, labelTwo) => {
    let diffs = {};
    Object.entries(objectOne).forEach(([key, val]) => {
        if (objectOne[key] !== objectTwo[key]) {
            diffs[key] = {
                [labelOne ?? 'objectOne']: objectOne[key],
                [labelTwo ?? 'objectTwo']: objectTwo[key],
            };
        }
    });
    // Catch any keys that aren't in obj 1
    Object.entries(objectTwo).forEach(([key, val]) => {
        if (objectOne[key] === undefined && objectTwo[key] !== undefined) {
            diffs[key] = {
                [labelOne ?? 'objectOne']: objectOne[key],
                [labelTwo ?? 'objectTwo']: objectTwo[key],
            };
        }
    });
    return diffs;
};
